import PropTypes from 'prop-types'
import React from 'react'
import FilteringHeaderRow from '#components/m/AzubiFilter/FilteringHeaderRow'
import {HeaderRow} from '#components/m/HeaderRow'

export function AzubiTableHeader(props) {
  const {filterRules, optionsDictionary, sendMailToAusbilder, withFilter} = props

  if (withFilter) {
    return (
      <thead>
        <tr>
          <FilteringHeaderRow filterRules={filterRules} filterOptionsDictionary={optionsDictionary} />
          <th />
          {sendMailToAusbilder && <th />}
        </tr>
      </thead>
    )
  }
  return (
    <thead>
      <tr>
        <HeaderRow headerOptions={optionsDictionary} />
        <th />
      </tr>
    </thead>
  )
}

AzubiTableHeader.propTypes = {
  filterRules: PropTypes.array,
  optionsDictionary: PropTypes.array,
  sendMailToAusbilder: PropTypes.bool,
  withFilter: PropTypes.bool,
}
